const DashedIcon = () => {
  return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        viewBox="0 0 75 2"
        fill="none"
      >
        <path
          d="M1 1H74"
          stroke="#B3B3B3"
          strokeLinecap="round"
          strokeDasharray="2 2"
        />
      </svg>
  );
};
export default DashedIcon;
